module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 15 15\"><defs><circle id=\"a\" cx=\"53.5\" cy=\"69.5\" r=\"7.5\"></circle></defs><g fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(-46 -62)\"><use fill=\"#E79309\" xlink:href=\"#a\"></use><circle cx=\"53.5\" cy=\"69.5\" r=\"5.5\" stroke=\"#FFF\" stroke-width=\"4\"></circle><circle cx=\"53.5\" cy=\"69.5\" r=\"6.5\" stroke=\"#E79309\" stroke-width=\"2\"></circle></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_oval.svg
// module id = 293
// module chunks = 1